import React from "react";

export default function FunFacts() {
  const facts = [
    { emoji: "🌈", text: "Favorite color: Orange" },
    { emoji: "🐶", text: "Best doggie friends: Bailey & Poppy" },
    { emoji: "🎬", text: "Loves movie nights" },
    { emoji: "🎵", text: "Enjoys music" },
    { emoji: "💛", text: "Superpower: Being incredibly brave" },
    { emoji: "😄", text: "Brings smiles wherever she goes" },
  ];

  return (
    <section className="py-16 px-6 max-w-5xl mx-auto">
      <h2 className="text-3xl font-bold text-yellow-700 text-center mb-4">
        Fun Facts About Millie
      </h2>

      <p className="text-center text-gray-700 max-w-2xl mx-auto mb-10">
        A few sweet things that make Millie who she is 💛
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {facts.map((fact, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-lg p-6 flex items-center space-x-4 hover:scale-105 transition-transform duration-300"
          >
            <span className="text-4xl">{fact.emoji}</span>
            <p className="text-gray-800 font-medium">{fact.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
